jQuery(document).ready(function($){

  var table = $('.product-list-table');

  $('.product-name-sort , .product-sku-sort')
  //.wrapInner('<span title="sort this column"/>')
  .each(function(){

    var th = $(this),
        thIndex = th.index(),
        inverse = false;

    th.click(function(){
      if($(this).hasClass('desc')){
        $(this).removeClass('desc');
      }else {
        $(this).addClass('desc');
      }
      table.find('td').filter(function(){

        return $(this).index() === thIndex;

      }).sortElements(function(a, b){

        return $.text([a]) > $.text([b]) ?
          inverse ? -1 : 1
        : inverse ? 1 : -1;

      }, function(){

        // parentNode is the element we want to move
        return this.parentNode; 

      });

      inverse = !inverse;

    });

  });
});

var modal = document.getElementById("quickShopModal");

var btn = document.getElementById("quickShopBtn");

var span = document.getElementsByClassName("quickShopclose")[0];

var sortProductName = document.getElementsByClassName("product-name-sort")[0];

btn.onclick = function() {
  modal.style.display = "block";
  sortProductName.click();
}

span.onclick = function() {
  modal.style.display = "none";
}

window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
